import React, { useState, useCallback } from 'react';
import {
  Modal,
  Button,
  DisplayText,
  TextContainer,
  ButtonGroup
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CustomModal, getTranslatedText } from '@nile/components';

function CustomWarningModal(props) {
  const [active, setActive] = useState(false);
  const {
    intl,
    modalActivator,
    title,
    description,
    content,
    primaryBtn,
    primaryBtnText,
    primaryBtnIcon
  } = props;
  const handleChange = useCallback(() => setActive(!active), [active]);

  const handleConfirm = useCallback(() => {
    if (props.onConfirmation) {
      props.onConfirmation();
    }
    handleChange();
  });

  return (
    <div>
      {modalActivator ? (
        <div onClick={handleChange} id={props.id}>
          {modalActivator}
        </div>
      ) : (
        <Button
          onClick={handleChange}
          id={props.id}
          superid={props.id}
          destructive={props?.destructive}
          plain={props?.plain}
          icon={
            <div id="delete-modal">
              <SVGIcon name="Delete" />
            </div>
          }
        >
          {props?.noIcon && 'Delete'}
        </Button>
      )}

      <CustomModal open={active} onClose={handleChange}>
        <div style={{ width: props?.modalWidth }} className="white-bg br10 p20">
          <div className="fx actr jctr g10 p20">
            {content || (
              <>
                <SVGIcon name="WarningIcon" size="xl" color="#F07602" />
                <div className="fx fcol g10 pb20">
                  <div>{title || 'title'}</div>
                  <div>{description || 'description'}</div>
                </div>
              </>
            )}
          </div>
          <div className="fx actr jend">
            <ButtonGroup spacing="loose">
              <Button plainSecondary onClick={handleChange}>
                <FormattedMessage id="common.cancel" />
              </Button>
              <div onClick={handleConfirm}>
                {primaryBtn || (
                  <Button
                    primary
                    icon={
                      primaryBtnIcon && (
                        <SVGIcon name={primaryBtnIcon} color="#ffffff" />
                      )
                    }
                  >
                    <FormattedMessage id={primaryBtnText || 'common.confirm'} />
                  </Button>
                )}
              </div>
            </ButtonGroup>
          </div>
        </div>
      </CustomModal>
    </div>
  );
}

export default injectIntl(CustomWarningModal);
